<template lang="pug">
.banner
  #triangle-pics.triangle-pics
    .triangle-pic
      img(:src="`/static/img/banner-0${step}.jpg`")
  .banner-block
  .banner-text
    .container
      .block-title
        h1 前沿社是企业家自我提升的
        h1.cn 「加速器」
      .block-list
        dl
          dd 持续输入
          dd 刷新认知
          dd 创造改变
        a(href='/video')
          | 观看视频
          .play
            .triangle-right
      .notes
        p 让自己成为企业成长的动力而不是瓶颈
        p 像那些优秀科技领袖那样引领变革而不是被变革
        p 看到更多新可能，突破今天面对的成长极限
      .links
        a(href="/entry")
          | 成为会员
          .triangle-right
        //- a(href="/observer")
        //-   | 成为观察员
        //-   .triangle-right
</template>

<script>
import $ from 'jquery'

export default {
  name: 'banner',
  data () {
    return {
      step: 1
    }
  },
  mounted(){
    setInterval(()=>{this.step = this.step % 5 + 1}, 6000)
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
@keyframes moveBg {
  from {
    transform: scale(1.2) translate(2%, 5%);
  }
  to {
    transform: scale(1) translate(0%, 0%);
  }
}


.banner
  position relative
  color #fff

  .triangle-pics
    position relative
    width 100%
    min-width 1080px
    overflow hidden
    padding-bottom 100px
    background #000
    img
      display block
      width 100%
      animation moveBg 20s linear
      animation-direction alternate
      animation-iteration-count infinite

    .triangle-pic-slide
      position absolute
      top 0
      left 0
      opacity 0
      transition opacity 2s

      &.active
        opacity 1
        transition opacity 2s

  .banner-block
    position absolute
    left 0
    top 0
    bottom 0
    right 0
    padding-bottom 300px
    background-image linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, .6));
  .banner-text
    position absolute
    bottom 110px
    width 100%
    text-align left
    .block-title
      display inline-block
      padding-right 40px
      margin-right 60px
      border-right 7px solid #fff
      box-sizing border-box
      vertical-align middle
      h1
        text-align left
        font-family 'FZLTTHCJW--GB1-0'
        font-size 54px
        text-transform uppercase
        letter-spacing 1px
        margin-bottom 15px
        &.cn
          font-family 'FZLTTHCJW--GB1-0'
          font-size 80px
          text-indent -.35em
          letter-spacing 10px
          margin-bottom 0px
    .block-list
      box-sizing border-box
      display inline-block
      vertical-align middle
      text-align left
      dl
        margin-bottom 20px
        dd
          font-size 55px
          font-family 'Noto Sans SC', sans-serif
          font-weight 300
          display inline-block
          width 110px
          padding-right 50px
          &:last-child
            padding-right 0
      a
        font-size 16px
        color #5FC4FF
        font-weight bold
    .notes
      margin-top 100px
      text-align left
      font-size 28px
      line-height 1.6em
      font-family 'Noto Sans SC', sans-serif
      font-weight 300
    .links
      display flex
      justify-content space-around
      margin-top 40px
      a
        color #5EC5FF
        display inline-block
        border 0.1em solid currentColor
        padding 0.5em 2em
        font-size 24px
        font-weight bolder
        &:hover
          color #000
          background-color #5EC5FF
          border-color #5EC5FF
.play
  border 2px solid currentColor
  display inline-block
  border-radius 50%
  width 1.5em
  height 1.5em
  vertical-align middle
  margin-left .5em
  padding .1em 0 0 .2em
  box-sizing border-box
  line-height 15em
  > div
    font-size 15px

.triangle-right
  display inline-block
  vertical-align top
  margin .1em .3em
  width 0
  height 0
  border-top .4em solid transparent
  border-left .5em solid currentColor
  border-bottom .4em solid transparent
</style>



// WEBPACK FOOTER //
// Banner.vue?8293abbe